import React, { useState, useEffect, Suspense, useCallback } from 'react'
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { Skeleton, notification } from 'antd'

import { isMobile } from '@/utils/util'
import getRoutes from '../routes'
import { useUserResources, useAppSelector } from '../utils/hooks'

import './App.less'

const App: React.FC = () => {
  const { userInfo, region } = useAppSelector(state => state.app)
  const [authorityRoutes, setAuthorityRoutes] = useState<Routes>([])
  const userResources = useUserResources(resources => resources)
  // 权限设置
  useEffect(() => {
    const routes = getRoutes(userResources, userInfo?.user, region)
    setAuthorityRoutes(routes)
  }, [userResources, userInfo?.user, region])

  useEffect(() => {
    if (isMobile()) {
      notification.info({
        message: '温馨提示',
        description: '移动设备建议横屏使用，效果更好！',
        duration: 6,
        placement: 'bottomRight',
      })
    }
  }, [])

  /**
   * 初始化根证书检测 SDK（托管弹窗模式）
   * 当用户信息加载完成后执行检测，使用 misId 作为用户标识
   */
  const initCertCheck = useCallback(async (userId: string): Promise<void> => {
    try {
      if (!window.BfePkiCertManager?.init) {
        console.warn('[CertCheck] BfePkiCertManager 未加载，跳过证书检测')
        return
      }
      const result = await window.BfePkiCertManager.init({
        // 业务域名标识
        bizName: 'bike.meituan.com/galaxy',
        // 使用 misId 作为用户唯一标识
        userId,
        // 开启托管弹窗模式：检测到证书缺失时自动展示升级引导弹窗
        autoPopup: false,
      })
      console.log('[CertCheck] 证书检测完成，结果：', result)
    } catch (error) {
      // 检测到AI生成内容错误，需要人工介入上报或进行后续处理！
      console.error('[CertCheck] 证书检测异常：', error)
    }
  }, [])

  // 当用户信息就绪后触发证书检测
  useEffect(() => {
    const misId = userInfo?.user?.misId
    if (!misId) return
    initCertCheck(misId)
  }, [userInfo?.user?.misId, initCertCheck])

  return (
    <Router>
      <Suspense fallback={<Skeleton active></Skeleton>}>
        <Switch>
          <Redirect exact from="/" to="/dataCenter" />
          {authorityRoutes.map(route => (
            <Route
              key={route.path}
              path={route.path}
              render={props => <route.component {...props} routes={route.routes} />}
            />
          ))}
        </Switch>
      </Suspense>
    </Router>
  )
}

export default App
